import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { selectSelectedOrganization } from '../../stateManagement/selectedOrganizationSlice';
import GridTable, { defaultPaginationData, GridColumnType, PaginationType } from '../../gridTable/GridTable';
import UserFavoriteOrganizationService from '../../services/UserFavoriteOrganizationService';
import { UserFavoriteOrganizationByOrganizationIdFilterDto, UserFavoriteOrganizationByOrganizationId } from "@ontime/types";
import { PhoneCountryCode } from "@ontime/types";

const AppointmentUserList: React.FC<{
    state: 'mount' | 'unmount' | 'mountByFilter';
    loading: boolean;
    setLoading: (input: boolean) => void;
    handleClose?: () => void;
    handleSelect?: (input: UserFavoriteOrganizationByOrganizationId) => void;
}> = ({ state, loading, setLoading, handleClose, handleSelect }) => {

    const organization = useSelector(selectSelectedOrganization);

    const [appointmentUsers, setAppointmentUsers] = useState<UserFavoriteOrganizationByOrganizationId[]>([]);
    const [paginationData, setPaginationData] = useState<PaginationType>(defaultPaginationData);
    const [filterDto, setFilterDto] = useState<UserFavoriteOrganizationByOrganizationIdFilterDto>({ organizationId: organization.organizationId ?? '', emailAddress: '', fullName: '', phoneNumber: '' });
    const { enqueueSnackbar } = useSnackbar();

    const getAll = async () => {
        setLoading(true);
        try {
            const response = await UserFavoriteOrganizationService.GetAllByOrganizationId(filterDto, paginationData);
            setAppointmentUsers(response.data.result.items);
            setPaginationData({ ...paginationData, totalCount: response.data.result.totalCount });

        } catch (error) {
            console.error(error, { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const appointmentUserType: GridColumnType<UserFavoriteOrganizationByOrganizationId> = {
        appointmentUserId: { dontShow: true },
        version: { dontShow: true },
        phoneCountryCode: { type: "Enum", header: 'Country Ccde', required: true, enumObject: PhoneCountryCode, dontShow: true },
        phoneNumber: { type: "Phone", header: 'Phone', searchableOnTop: true, required: true },
        fullName: { type: "Text", header: 'Full Name', required: true },
        emailAddress: { type: "Text", header: 'Email', searchableOnTop: true, showInCreateRow: true },
    };

    useEffect(() => {
        if (state === 'mount' && organization.organizationId) {
            getAll();
        }
        else if (state === 'mountByFilter' && organization.organizationId &&
            (filterDto.emailAddress || filterDto.fullName || filterDto.phoneNumber)) {
            getAll();
        }
        else if (state === 'unmount') {
            setFilterDto({ organizationId: organization.organizationId ?? 0, emailAddress: '', fullName: '', phoneNumber: '' });
            setAppointmentUsers([]);
            setPaginationData(defaultPaginationData);
        };
    }, [state, paginationData.skipCount, paginationData.maxResultCount]);

    return (

        <GridTable<UserFavoriteOrganizationByOrganizationId, UserFavoriteOrganizationByOrganizationIdFilterDto, UserFavoriteOrganizationByOrganizationId>
            gridTitle='User list'
            loading={loading}
            list={appointmentUsers.map((item) => ({ ...item, id: item.appointmentUserId }))}
            inputType={appointmentUserType}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            filterDto={filterDto}
            setFilterDto={setFilterDto}
            onClickRow={handleSelect}
            searchButtonTop={getAll}
            isOnDialog={true}
            onClickBack={handleClose}
        />
    );
};

export default AppointmentUserList;
